var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-gray wraper" }, [
    _c(
      "div",
      { staticClass: "panel-header" },
      [
        _c("span", [
          _vm._v(
            'Результаты поиска "' +
              _vm._s(_vm.$store.state.searchResults.term) +
              '" (' +
              _vm._s(_vm.total) +
              ")"
          )
        ]),
        _vm._v(" "),
        _c(
          "q-btn",
          {
            attrs: {
              round: "",
              small: "",
              flat: "",
              icon: "fa-search",
              color: "secondary"
            },
            on: {
              click: function($event) {
                _vm.$router.push("/search")
              }
            }
          },
          [
            _c(
              "q-tooltip",
              {
                attrs: {
                  self: "center left",
                  anchor: "center right",
                  delay: 500
                }
              },
              [_vm._v("Новый поиск")]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "panel-group",
        class: { scroll: _vm.$route.meta.showLeft }
      },
      [
        _vm._l(_vm.visibleItems, function(item, index) {
          return _c("result-item", {
            key: item.id,
            class: { selected: index === _vm.activeIndex },
            attrs: { index: index, item: item }
          })
        }),
        _vm._v(" "),
        _c(
          "my-scroll",
          { ref: "myscroll", attrs: { handler: _vm.getMore } },
          [_c("q-spinner-dots", { attrs: { size: 40 } })],
          1
        ),
        _vm._v(" "),
        _c(
          "q-btn",
          {
            directives: [
              {
                name: "back-to-top",
                rawName: "v-back-to-top.animate",
                value: 500,
                expression: "500",
                modifiers: { animate: true }
              }
            ],
            staticClass: "fixed-bottom-left",
            staticStyle: { margin: "0 0 15px 15px" },
            attrs: { round: "", color: "teal-5" }
          },
          [_c("q-icon", { attrs: { name: "keyboard_arrow_up" } })],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc1156c0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc1156c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/result-list.vue
// module id = null
// module chunks = 